import React from 'react';

export const Table = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" data-name="Ebene 1" viewBox="0 0 80 80">
            <path d="M67 14H13c-3.86 0-7 3.14-7 7v38c0 3.86 3.14 7 7 7h54c3.86 0 7-3.14 7-7V21c0-3.86-3.14-7-7-7ZM38 28.49V37H26.15v-8.51H38ZM38 41v8.51H26.15V41H38Zm0 12.51v8.5H26.15v-8.5H38Zm4 0h12.15v8.5H42v-8.5Zm0-4V41h12.15v8.51H42ZM42 37v-8.51h12.15V37H42Zm-32-8.51h12.15V37H10v-8.51ZM10 41h12.15v8.51H10V41Zm0 18.01v-5.5h12.15v8.5H13c-1.65 0-3-1.35-3-3Zm60 0c0 1.65-1.35 3-3 3h-8.85v-8.5H70v5.5Zm0-9.5H58.15V41H70v8.51ZM70 37H58.15v-8.51H70V37Z" />
        </svg>
    );
};
